import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(cleanupReservationModal);

import { all, call } from 'redux-saga/effects';
import { createReservation, userActionCampaignEvent } from 'redux/saga/entities/bound';
import { resetEntity } from 'redux/saga/helpers/reset-entity';
export function cleanupReservationModal() {
  return regeneratorRuntime.wrap(function cleanupReservationModal$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([call(resetEntity, createReservation), call(resetEntity, userActionCampaignEvent)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}